//处理行程标题
function handleDayTitle(journeyTitle) {
    if (journeyTitle) {
      let reg = /\{[a-zA-Z]+\}/g;
      let title = journeyTitle.replace(reg, function (str) {
        if (str == "{plane}") {
          str = '//m.tuniucdn.com/fb2/t1/G6/M00/33/A7/Cii-U13U7uqIXrwgAAABs7jPWcoAAFC6QP__jUAAAHL186.png';
        }
        else if (str == "{boat}") {
          str = '//m.tuniucdn.com/fb2/t1/G6/M00/36/DD/Cii-TF3U7uuIGhnaAAABmbTb43EAAFLQwP__k8AAAGx161.png';
        }
        else if (str == "{train}") {
          str = '//m1.tuniucdn.com/fb2/t1/G6/M00/30/D0/Cii-TF3U7uqIYc0vAAABp3CvXm8AAE4SAP__kEAAAG_981.png';
        }
        else if (str == "{car}") {
          str = '//m3.tuniucdn.com/fb2/t1/G6/M00/30/7C/Cii-U13U7uqIOr-VAAABQK-7gYkAAE3aAP__qgAAAFY316.png';
        }
        else {
          str = '//m.tuniucdn.com/fb2/t1/G6/M00/26/53/Cii-U13U7uqIEt82AAAA4J5ah3gAAEddAP__vwAAAEE733.png';
        }
        return '+' + str + '+'
      });
      let strArray = title.split('+');
      let res = [];
      strArray.forEach((item) => {
        if (item.search('png') > -1) {
          res.push({
            type: 'image',
            content: item
          });
        }
        else {
          res.push({
            type: 'txt',
            content: item
          })
        }
      });
      return res;
    }
    else {
      return [];
    }
  }
  
  //处理行程内容
  function handleDayContent(oneday) {
    let contents = [];
    if (!oneday) {
      return contents;
    }
    if (!!oneday.scenic) {
      contents.push({
        name: '景点:',
        iconUrl: '@/assets/journeyOverview/journey-overview-scenic@2x.png',
        content: oneday.scenic
      });
    }
    if (!!oneday.hotel) {
      contents.push({
        name: '住宿:',
        iconUrl: '//m1.tuniucdn.com/fb2/t1/G6/M00/2F/A3/Cii-TF3U7uuIA3oTAAABpyPg2AEAAE2DAP__kEAAAG_419.png',
        content: oneday.hotel
      });
    }
    if (!!oneday.food) {
      contents.push({
        name: '餐饮:',
        iconUrl: '//m.tuniucdn.com/fb2/t1/G6/M00/36/68/Cii-TF3U7uyIbIcjAAABfB9rtdQAAFJZAP__mwAAAGU745.png',
        content: oneday.food
      });
    }
    if (!!oneday.shopping) {
      contents.push({
        name: '购物:',
        iconUrl: '//m4.tuniucdn.com/fb2/t1/G6/M00/34/1A/Cii-U13U7uqIGr4CAAABpIL3RfwAAFFGwP__kQAAAG8444.png	',
        content: oneday.shopping
      });
    }
    if (!!oneday.activity) {
      contents.push({
        name: '自由活动:',
        iconUrl: '//m1.tuniucdn.com/fb2/t1/G6/M00/31/F1/Cii-TF3U7uyIBnxMAAAC3It0DXIAAE62AP__QwAAAL0592.png',
        content: oneday.activity
      });
    }
    return contents;
  }
  
  function handleJourneyOverviews(overviews) {
    if (overviews && overviews.length > 0) {
      overviews.forEach((day) => {
        day.dayTitles = handleDayTitle(day.journeyDescription);
        day.dayContents = handleDayContent(day);
      });
    }
    return overviews;
  }
  
  /**
   * 组装自助资源线行程
   */
  function handleResJourneyDetail(detailData) {
    let details = [];
    if (detailData && detailData.length > 0) {
      detailData.forEach((detail) => {
        if (detail.data && detail.data.length > 0) {
          detail.data.forEach((resDetail) => {
            resDetail = composeResJourneyTitle(resDetail);
            if(resDetail.content){
              details.push(resDetail);
            }
          });
        }
      });
    }
    return details;
  }
  
  /**
   * 根据type组装行程信息
   */
  function composeResJourneyTitle(resDetail) {
    if (!resDetail) {
      return resDetail;
    }
    if (resDetail.moduleTypeValue == 1) {
      resDetail.title = '景点：';
      let scenicName = '';
      let scenicDes = '';
      if (resDetail.data && resDetail.data.length > 0) {
        resDetail.data.forEach((scenic) => {
          if (scenicName) {
            scenicName = scenicName + ' - ';
          }
          if (scenic && scenic.title) {
            scenicName = scenicName + scenic.title;
          }
          if (scenicDes) {
            scenicDes = scenicDes + '\n';
          }
          if (scenic && scenic.content) {
            scenicDes = scenicDes + scenic.content;
          }
        });
      }
      resDetail.name = scenicName;
      resDetail.content = scenicDes;
      resDetail.iconUrl = '@/assets/journeyDetail/journey-detail-scenic@2x.png';
    } else if (resDetail.moduleTypeValue == 2) {
      resDetail.title = '住宿：';
      let hotelName = '';
      if (resDetail.data && resDetail.data.length > 0) {
        resDetail.data.forEach((hotel) => {
          if (hotelName) {
            hotelName = hotelName + ' 或 ';
          }
          if (hotel && hotel.title) {
            hotelName = hotelName + hotel.title;
          }
        });
      }
      resDetail.name = hotelName;
      resDetail.content = resDetail.poiDescription;
      resDetail.iconUrl = '@/assets/journeyDetail/journey-detail-hotel@2x.png';
    } else if (resDetail.moduleTypeValue == 3) {
      resDetail.title = '交通：';
      resDetail.content = resDetail.poiDescription;
      resDetail.iconUrl = '@/assets/journeyDetail/journey-detail-traffic@2x.png';
    } else if (resDetail.moduleTypeValue == 4) {
      let foodName = '';
      if (resDetail.hasInfoList && resDetail.hasInfoList.length > 0) {
        resDetail.hasInfoList.forEach((meal) => {
          if (foodName) {
            foodName = foodName + '\n';
          }
          if (meal.type) {
            if (meal.type === 'breakfast') {
              foodName = foodName + '早餐：' + (meal.has === 0 ? '敬请自理' : '已含');
            } else if (meal.type === 'lunch') {
              foodName = foodName + '午餐：' + (meal.has === 0 ? '敬请自理' : '已含');
            } else if (meal.type === 'dinner') {
              foodName = foodName + '晚餐：' + (meal.has === 0 ? '敬请自理' : '已含');
            } else if (meal.type === 'allDay') {
              foodName = foodName + '全天用餐：' + (meal.has === 0 ? '敬请自理' : '已含');
            }
          }
        });
      }
      resDetail.title = foodName;
      resDetail.content = resDetail.poiDescription;
      resDetail.iconUrl = '@/assets/journeyDetail/journey-detail-food@2x.png';
    } else if (resDetail.moduleTypeValue == 5) {
      resDetail.title = '购物店信息';
      resDetail.content = resDetail.poiDescription;
      resDetail.iconUrl = '@/assets/journeyDetail/journey-detail-shopping@2x.png';
    } else if (resDetail.moduleTypeValue == 6) {
      resDetail.title = '自由活动';
      resDetail.content = resDetail.poiDescription;
      resDetail.iconUrl = '@/assets/journeyDetail/journey-detail-activity@2x.png';
    } else if (resDetail.moduleTypeValue == 7) {
      if (resDetail.type) {
        resDetail.title = resDetail.type;
      } else {
        resDetail.title = '温馨提示';
      }
      resDetail.iconUrl = '@/assets/journeyDetail/journey-detail-default@2x.png';
    } else {
      resDetail.title = '其它';
      resDetail.content = resDetail.poiDescription + resDetail.content;
      resDetail.iconUrl = '@/assets/journeyDetail/journey-detail-default@2x.png';
    }
  
    return resDetail;
  }
  
  function composeResJourneyContent(resDetail) {
    if (!resDetail) {
      return resDetail;
    }
    resDetail.content = resDetail.content;
  }
  
  module.exports = {
    handleJourneyOverviews: handleJourneyOverviews,
    handleResJourneyDetail: handleResJourneyDetail
  }
  


// WEBPACK FOOTER //
// libs/util/journeyUtils.js